import React from "react";
import PropTypes from "prop-types";
import ClimateDetails from "~/assets/js/components/ClimateDetails";
import { filterNutrientsByNutrientsNames } from "~/assets/js/Format";
import { nutrientNamesTranslations } from ".";

const NutrientDressingCard = ({ dressing }) => {
    const { details } = dressing;

    const nutrients = filterNutrientsByNutrientsNames(details);

    return (
        <>
            <div className="nutrient-dressing-card">
                <div className="nutrient-dressing-card__img">
                    <img src={dressing.images.normal} alt="dressing" />
                </div>
                <div className="nutrient-dressing-card__content">
                    <p className="nutrient-dressing-card__content__name">
                        {dressing.name}
                    </p>

                    <ClimateDetails climateDetails={details} />

                    <div className="nutrient-dressing-card__content__nutrients">
                        {Object.keys(nutrients).map((key) => {
                            const unit = "g";
                            if (null !== nutrients[key] && key !== "energy")
                                return (
                                    <p key={key}>
                                        {`${nutrients[key]} ${unit} ${nutrientNamesTranslations[key]}`}
                                    </p>
                                );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

NutrientDressingCard.propTypes = {
    dressing: PropTypes.object,
};

export default NutrientDressingCard;
